import { Component, Input, OnChanges, OnInit, forwardRef } from '@angular/core';
import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { TextFieldModel } from '../../../models/text-field.model';
import { ResizeDirectionEnum } from '../../../../Forms/components/TextareaInput/textarea-input.component';
@Component({
    selector: 'agpr-text-field',
    templateUrl: './text-field.component.html',
    styleUrls: ['./text-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => TextFieldComponent)
        }
    ],
    standalone: false
})
export class TextFieldComponent extends AbstractFormFieldComponent implements OnInit, OnChanges {
    @Input() declare field: TextFieldModel;
    errorMessage: string;
    showField: boolean = true;
    style: { [key: string]: string } = {}; // custom styles

    ngOnInit() {
        const { indent } = this.field?.style ?? {};

        if (indent) {
            this.style['margin-left'] = `${indent}px`;
        }
    }

    ngOnChanges() {
        if (this.field?.appearCondition) {
            this.showField = this.field.appearCondition(this.block.displayElement);
        }
    }

    trimValue() {
        if (this.field.trimValue) {
            this.value = this.value.trim();
        }
    }

    validate(value: string): void {
        if (this.field.validator) {
            this.errorMessage = this.field.validator(value);
        }
    }

    onChange(event: Event) {
        this.trimValue();
        this.validate(this.value);
        this.changes.emit(this.value);
    }
}

